/*
 * File: \app\resourceCenter\XinhuaNews\directive\atlasCarouselWindow\atlasCarouselWindow.js
 * Description:
 * Create Date: 2020-05-13
 * Author: he.jianbo
 * Author Email: hjb2722404@163.com
 * -----
 * Last Modified: 2020-05-13 上午10:36:42
 * Modified By: he.jianbo
 * modify description:
 * -----
 * HISTORY:
 * 日期                    	作者	说明
 * -----------	---	----------------------------------------------------------
 */
angular.module('resCtrModalModule').controller('commentCtrl', [
    '$scope',
    '$modalInstance',
    'options',
    '$validation',
    '$q',
    function(
        $scope,
        $modalInstance,
        options,
        $validation,
        $q
    ) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.windowTitle = options.windowTitle || '版面评价';
            $scope.status = {

            };
            $scope.data = {
                data: '',
                title: '',
                placeholder: options.placeholder || '请输入评价内容'
            };
        }

        /**
         * [initData 初始化图片数组]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.data.data = options;
            // $scope.data.title = options.title || '';
        }

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        $scope.save = function() {
            $modalInstance.close({
                data: $scope.data.data,
            });
        };

        $scope.confirm = function () {
            var deferred = $q.defer();
            $validation
                .validate($scope.commonForm)
                .success(function () {
                    $modalInstance.close({
                        data: $scope.data,
                    });
                })
                .error(function () {
                    deferred.reject();
                });
            return deferred.promise;

            
        };
        
    },
]);
